var map = {
	"./content.nq.read/README.md": 333,
	"./content.nq.read/main": 57,
	"./content.nq.read/main.js": 57,
	"./content.nq.read/package": 187,
	"./content.nq.read/package.json": 187,
	"./content.nq.scan/README.md": 340,
	"./content.nq.scan/main": 107,
	"./content.nq.scan/main.js": 107,
	"./content.nq.scan/package": 192,
	"./content.nq.scan/package.json": 192,
	"./content.nq.scan/task-presets": 110,
	"./content.nq.scan/task-presets.js": 110,
	"./content.nq.scan/worker": 193,
	"./content.nq.scan/worker.js": 193,
	"./content.nq.scribe/README.md": 346,
	"./content.nq.scribe/main": 111,
	"./content.nq.scribe/main.js": 111,
	"./content.nq.scribe/package": 194,
	"./content.nq.scribe/package.json": 194,
	"./content.nq.write/README.md": 347,
	"./content.nq.write/main": 112,
	"./content.nq.write/main.js": 112,
	"./content.nq.write/package": 195,
	"./content.nq.write/package.json": 195,
	"./content.nt.read/README.md": 348,
	"./content.nt.read/main": 61,
	"./content.nt.read/main.js": 61,
	"./content.nt.read/package": 196,
	"./content.nt.read/package.json": 196,
	"./content.nt.scan/README.md": 349,
	"./content.nt.scan/main": 113,
	"./content.nt.scan/main.js": 113,
	"./content.nt.scan/package": 197,
	"./content.nt.scan/package.json": 197,
	"./content.nt.scan/task-presets": 114,
	"./content.nt.scan/task-presets.js": 114,
	"./content.nt.scan/worker": 198,
	"./content.nt.scan/worker.js": 198,
	"./content.nt.scribe/README.md": 350,
	"./content.nt.scribe/main": 115,
	"./content.nt.scribe/main.js": 115,
	"./content.nt.scribe/package": 199,
	"./content.nt.scribe/package.json": 199,
	"./content.nt.write/README.md": 351,
	"./content.nt.write/main": 116,
	"./content.nt.write/main.js": 116,
	"./content.nt.write/package": 200,
	"./content.nt.write/package.json": 200,
	"./content.trig.read/README.md": 352,
	"./content.trig.read/main": 117,
	"./content.trig.read/main.js": 117,
	"./content.trig.read/package": 202,
	"./content.trig.read/package.json": 202,
	"./content.trig.scribe/README.md": 353,
	"./content.trig.scribe/main": 118,
	"./content.trig.scribe/main.js": 118,
	"./content.trig.scribe/package": 203,
	"./content.trig.scribe/package.json": 203,
	"./content.trig.write/README.md": 354,
	"./content.trig.write/main": 119,
	"./content.trig.write/main.js": 119,
	"./content.trig.write/package": 204,
	"./content.trig.write/package.json": 204,
	"./content.ttl.read/README.md": 355,
	"./content.ttl.read/main": 120,
	"./content.ttl.read/main.js": 120,
	"./content.ttl.read/package": 205,
	"./content.ttl.read/package.json": 205,
	"./content.ttl.scribe/README.md": 356,
	"./content.ttl.scribe/main": 121,
	"./content.ttl.scribe/main.js": 121,
	"./content.ttl.scribe/package": 206,
	"./content.ttl.scribe/package.json": 206,
	"./content.ttl.write/README.md": 357,
	"./content.ttl.write/main": 122,
	"./content.ttl.write/main.js": 122,
	"./content.ttl.write/package": 207,
	"./content.ttl.write/package.json": 207,
	"./content.xml.scribe/README.md": 358,
	"./content.xml.scribe/main": 123,
	"./content.xml.scribe/main.js": 123,
	"./content.xml.scribe/package": 208,
	"./content.xml.scribe/package.json": 208,
	"./core.class.scribable/README.md": 359,
	"./core.class.scribable/main": 32,
	"./core.class.scribable/main.js": 32,
	"./core.class.scribable/package": 209,
	"./core.class.scribable/package.json": 209,
	"./core.class.writable/README.md": 360,
	"./core.class.writable/main": 47,
	"./core.class.writable/main.js": 47,
	"./core.class.writable/package": 210,
	"./core.class.writable/package.json": 210,
	"./core.data.factory/README.md": 361,
	"./core.data.factory/main": 10,
	"./core.data.factory/main.js": 10,
	"./core.data.factory/package": 211,
	"./core.data.factory/package.json": 211,
	"./core.iso.stream/README.md": 362,
	"./core.iso.stream/main": 24,
	"./core.iso.stream/main.js": 24,
	"./core.iso.stream/node_modules/readable-stream/CONTRIBUTING.md": 363,
	"./core.iso.stream/node_modules/readable-stream/GOVERNANCE.md": 364,
	"./core.iso.stream/node_modules/readable-stream/LICENSE": 365,
	"./core.iso.stream/node_modules/readable-stream/README.md": 366,
	"./core.iso.stream/node_modules/readable-stream/errors": 28,
	"./core.iso.stream/node_modules/readable-stream/errors-browser": 28,
	"./core.iso.stream/node_modules/readable-stream/errors-browser.js": 28,
	"./core.iso.stream/node_modules/readable-stream/errors.js": 367,
	"./core.iso.stream/node_modules/readable-stream/experimentalWarning": 212,
	"./core.iso.stream/node_modules/readable-stream/experimentalWarning.js": 212,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_duplex": 31,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_duplex.js": 31,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_passthrough": 105,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_passthrough.js": 105,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_readable": 72,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_readable.js": 72,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_transform": 76,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_transform.js": 76,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_writable": 75,
	"./core.iso.stream/node_modules/readable-stream/lib/_stream_writable.js": 75,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/async_iterator": 104,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/async_iterator.js": 104,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/buffer_list": 103,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/buffer_list.js": 103,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/destroy": 73,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/destroy.js": 73,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/end-of-stream": 59,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/end-of-stream.js": 59,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/from": 60,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/from-browser": 60,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/from-browser.js": 60,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/from.js": 60,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/pipeline": 106,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/pipeline.js": 106,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/state": 74,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/state.js": 74,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/stream": 45,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/stream-browser": 45,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/stream-browser.js": 45,
	"./core.iso.stream/node_modules/readable-stream/lib/internal/streams/stream.js": 45,
	"./core.iso.stream/node_modules/readable-stream/package": 213,
	"./core.iso.stream/node_modules/readable-stream/package.json": 213,
	"./core.iso.stream/node_modules/readable-stream/readable": 58,
	"./core.iso.stream/node_modules/readable-stream/readable-browser": 58,
	"./core.iso.stream/node_modules/readable-stream/readable-browser.js": 58,
	"./core.iso.stream/node_modules/readable-stream/readable.js": 58,
	"./core.iso.stream/package": 214,
	"./core.iso.stream/package.json": 214,
	"./core.iso.threads/README.md": 368,
	"./core.iso.threads/main": 46,
	"./core.iso.threads/main.js": 46,
	"./core.iso.threads/master-browser": 108,
	"./core.iso.threads/master-browser.js": 108,
	"./core.iso.threads/master-node": 369,
	"./core.iso.threads/master-node.js": 370,
	"./core.iso.threads/package": 215,
	"./core.iso.threads/package.json": 215,
	"./core.iso.threads/worker-browser": 109,
	"./core.iso.threads/worker-browser.js": 109,
	"./core.iso.threads/worker-node": 371,
	"./core.iso.threads/worker-node.js": 372,
	"./memory.dataset.fast/README.md": 373,
	"./memory.dataset.fast/main": 78,
	"./memory.dataset.fast/main.js": 78,
	"./memory.dataset.fast/package": 216,
	"./memory.dataset.fast/package.json": 216,
	"./util.dataset.tree/README.md": 374,
	"./util.dataset.tree/main": 124,
	"./util.dataset.tree/main.js": 124,
	"./util.dataset.tree/package": 217,
	"./util.dataset.tree/package.json": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;